import React from 'react';

export enum FormType {
  RegistrationForm,
  EvaluationForm
}

export class FormTypeContextData {
  constructor(readonly type: FormType, readonly token: string) {

  }

  capitalizeToken(): string {
    return this.token[0].toUpperCase() + this.token.slice(1);
  }
}

export const RegistrationFormContextData = new FormTypeContextData(FormType.RegistrationForm, 'field');
export const EvaluationFormContextData = new FormTypeContextData(FormType.EvaluationForm, 'question');

export const FormTypeContext = React.createContext<FormTypeContextData>(RegistrationFormContextData);

export enum SideFormType {
  Section, Field, ListOfSections, ListOfFields
}

export enum ElementType {
  Section, Field
}

export enum ActionType {
  Created, Updated
}
